import React, { useState, useEffect, useRef } from "react";
import ModalChangePassword from "./ModalChangePassword";
import axios from "axios";
import { distributionUrl } from "../../Config/url";
import { useNavigate } from "react-router-dom";
import Ripples from "react-ripples";
const ModalForgot = ({ setPopup, setPopupType, setPopupMessage }) => {
  const navigate = useNavigate();
  const inputRefs = useRef([]);
  const formData = new FormData();
  const [canRequestOtpAgain, setCanRequestOtpAgain] = useState(false);
  const [otpInput, setOtpInput] = useState(false);
  const [changePassword, setChangePassword] = useState(false);
  const [otpNumbers, setOtpNumbers] = useState(["", "", "", ""]);
  const [otpTimer, setOtpTimer] = useState(30);
  const [forgotEmail, setForgotEmail] = useState("");

  const [continueButtonClickable, setContinueButtonClickable] = useState(true);
  const [OTPContinueButtonClickable, setOTPContinueButtonClickable] =
    useState(true);

  useEffect(() => {
    document.title = "MMusic - Мартсан";
  }, []);

  const handleChange = (index, value) => {
    const newInputs = [...otpNumbers];
    newInputs[index] = value;
    setOtpNumbers(newInputs);

    if (value.length === 1 && index < inputRefs.current.length - 1) {
      inputRefs.current[index + 1].focus();
    }
  };

  const handleKeyDown = (index, event) => {
    if (event.key === "Enter" && index < inputRefs.current.length - 1) {
      event.preventDefault(); // Prevent form submission on Enter key press
      inputRefs.current[index + 1].focus();
    }
  };
  useEffect(() => {
    const timer = setInterval(() => {
      setOtpTimer((prevSeconds) => prevSeconds - 1);
    }, 1000);

    return () => {
      clearInterval(timer);
    };
  }, []);
  useEffect(() => {
    if (otpTimer === 0) {
      setCanRequestOtpAgain(true);
    }
  }, [otpTimer]);
  const validateForgotRequest = (where) => {
    if (forgotEmail.includes(".") && forgotEmail.includes("@")) {
      if (continueButtonClickable || where === "resend") {
        setContinueButtonClickable(false);
        formData.append("email", forgotEmail);
        axios
          .post(distributionUrl + "panel-oauth/guest/forgot:validate", formData)
          .then((res) => {
            if (res.status === 200) {
              setOtpInput(true);
            }
            if (where === "resend") {
              setPopupType("Success");
              setPopupMessage("resendOTP");
              setPopup(true);
            }
          })
          .catch((err) => {
            setContinueButtonClickable(true);
            if (err.response.status === 422) {
              let backendMessage =
                err?.response?.data?.message || "mailNotGood";
              console.log(err.response?.data.message);
              setPopupType("Info");
              setPopupMessage(backendMessage);
              setPopup(true);
            }
          });
      }
    } else {
      setPopupType("Info");
      setPopupMessage("mailNotGood");
      setPopup(true);
    }
  };
  const validateOTP = () => {
    if (
      !!otpNumbers[0] &&
      !!otpNumbers[1] &&
      !!otpNumbers[2] &&
      !!otpNumbers[3]
    ) {
      if (OTPContinueButtonClickable) {
        setOTPContinueButtonClickable(false);
        formData.append("email", forgotEmail);
        formData.append(
          "pin",
          otpNumbers[0] + otpNumbers[1] + otpNumbers[2] + otpNumbers[3]
        );
        axios
          .post(distributionUrl + "panel-oauth/guest/forgot:verify", formData)
          .then((res) => {
            if (res.status === 200) {
              setChangePassword(true);
            }
          })
          .catch((err) => {
            setOTPContinueButtonClickable(true);
            if (err.response.status === 422) {
              setPopupType("Warning");
              setPopupMessage("otpFailed");
              setPopup(true);
            }
          });
      }
    } else {
      setPopupType("Warning");
      setPopupMessage("otpFailed");
      setPopup(true);
    }
  };
  const resendOTPHandler = () => {
    setOtpTimer(30);
    validateForgotRequest("resend");
    setCanRequestOtpAgain(false);
  };
  const otpInputs = otpNumbers.map((item, index) => {
    return (
      <input
        key={index}
        value={item}
        type="number"
        min={0}
        max={9}
        required
        className={`otp-border ${
          item.length <= 2 ? "otp-border" : "border-red"
        } `}
        onChange={(event) => handleChange(index, event.target.value)}
        onKeyDown={(event) => handleKeyDown(index, event)}
        ref={(ref) => (inputRefs.current[index] = ref)}
      />
    );
  });
  return (
    <>
      {changePassword ? (
        <ModalChangePassword
          forgotEmail={forgotEmail}
          otpNumbers={otpNumbers}
          setOtpInput={setOtpInput}
          setPopup={setPopup}
          setPopupType={setPopupType}
          setPopupMessage={setPopupMessage}
        />
      ) : (
        <div className="flex flex-col">
          {otpInput ? (
            <div
              className="flex flex-col"
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  validateOTP();
                }
              }}
            >
              <h5 className="font-semibold text-2xl pb-8 w-full text-center">
                Нууц үг мартсан
              </h5>
              <h5 className="text-base w-full text-center pb-8">
                Таны <span className="font-semibold">{forgotEmail}</span> цахим
                хаягт баталгаажуулах код илгээлээ та цахим хаягаа шалгана уу
              </h5>
              <h5 className="text-base pb-3">Баталгаажуулах код</h5>
              <div className="flex flex-row gap-2 ">{otpInputs}</div>
              <Ripples color="#ffffff40" during={600} className="rounded-lg">
                <div
                  className={`button mt-8 ${
                    OTPContinueButtonClickable
                      ? "cursor-pointer"
                      : "cursor-wait"
                  }`}
                  onClick={() => {
                    validateOTP();
                  }}
                >
                  <h5
                    className={`py-4 font-semibold text-base text-white ${
                      OTPContinueButtonClickable ? "" : "opacity-50"
                    }`}
                  >
                    {" "}
                    Үргэлжлүүлэх
                  </h5>
                </div>
              </Ripples>
              {canRequestOtpAgain ? (
                <Ripples color="#ffffff40" during={600} className="rounded-lg">
                  <h5
                    className={`text-base w-full text-center pt-6 cursor-pointer`}
                    onClick={() => {
                      resendOTPHandler();
                    }}
                  >
                    Хэрэв ирээгүй бол{" "}
                    <span className="font-medium text-mmusic">
                      ДАХИН ИЛГЭЭХ
                    </span>
                  </h5>
                </Ripples>
              ) : (
                <h5 className={`text-base w-full text-center pt-6 cursor-wait`}>
                  Та ({otpTimer}) секунд хүлээнэ үү.
                </h5>
              )}
            </div>
          ) : (
            <div
              className="flex flex-col"
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  validateForgotRequest("button");
                }
              }}
            >
              <h5 className="font-semibold text-2xl pb-8 w-full text-center">
                Нууц үг мартсан
              </h5>
              <h5 className="text-base w-full text-center pb-8">
                Та бүртгэлтэй мэйл хаягаа оруулна уу
              </h5>
              <h5 className="text-base pb-3">Мэйл</h5>
              <input
                type="email"
                placeholder="Мэйл оруулах"
                onChange={(value) => {
                  setForgotEmail(value.target.value);
                }}
              />
              <Ripples color="#ffffff40" during={600} className="rounded-lg">
                <div
                  className={`button mt-8 ${
                    continueButtonClickable ? "cursor-pointer" : "cursor-wait"
                  }`}
                  onClick={() => {
                    validateForgotRequest("button");
                  }}
                >
                  <h5
                    className={`py-4 font-semibold text-base text-white  ${
                      continueButtonClickable ? "" : "opacity-50"
                    }`}
                  >
                    Үргэлжлүүлэх
                  </h5>
                </div>
              </Ripples>
              <Ripples color="#ffffff40" during={600} className="rounded-lg">
                <h5
                  className="pt-6 w-full text-center cursor-pointer"
                  onClick={() => {
                    navigate("/login");
                  }}
                >
                  эсвэл <span className="text-mmusic font-medium">Нэвтрэх</span>
                </h5>
              </Ripples>
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default ModalForgot;
